import { ActionTypes } from "../constants";

const reduceAppraisers = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.GET_RMS_APPRAISERS_SUCCESS:
            return action.data || [];

        case ActionTypes.GET_RMS_APPRAISERS_FAILURE:
            return [];

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export default reduceAppraisers;
